import React, {useEffect, useState} from 'react';
import StudentLayout from "@/components/layout/student/studentLayout";
import {useParams} from "react-router-dom";
import {useApiReadStudentLessonDetail} from "@/api/lesson";
import RenderIf from "@/components/render-if";
import {Avatar, Badge, Spin} from "antd";
import {BookOpen, Calendar, Clock, UserIcon} from 'lucide-react';
import {formatDate, progressBetweenDates} from "@/lib/helper/date";
import {teacherGenderNames} from "@/pages/student/lessons/take/_section/LessonCard";
import {weekdayString} from "@/lib/helper/weekday";
import toFaNumber from "@/lib/utils/number";
import {lessonRegisterStatusEnum} from "@/lib/helper/enumType";
import StudentMyLessonPaymentHistorySection from "@/pages/student/lessons/myLesson/[id]/_section/PaymentHistorySection";
import HomeworkSection from "@/pages/student/lessons/myLesson/[id]/_section/HomeworkSection";
import InstallmentSection from "@/pages/student/lessons/myLesson/[id]/_section/InstallmentSection";
import RemoveLesson from "@/pages/student/lessons/myLesson/[id]/_section/RemoveLesson";
import ExamStartSection from "@/pages/student/lessons/myLesson/[id]/_section/ExamStartSection";
import {URLS} from "@/lib/urls";
import AbsenceSection from "@/pages/student/lessons/myLesson/[id]/_section/AbsenceSection";
import ShowMyLessonAddress from "@/pages/student/lessons/myLesson/[id]/_section/ShowMyLessonAddress";
import StudentMyLessonBookResourceSection from "@/pages/student/lessons/myLesson/[id]/_section/BookResourceSection";


function StudentShowMyLessonPage(props) {


    const param = useParams();

    const [startDate, setStartDate] = useState()
    const [endDate, setEndDate] = useState()

    const {data, isPending, isSuccess} = useApiReadStudentLessonDetail(param.id)


    useEffect(() => {
        if (data?.data?.data?.lesson?.startdate) {
            setStartDate(data?.data?.data?.lesson?.startdate)
        } else {
            if (data?.data?.data?.lesson?.semester?.start) {
                setStartDate(data?.data?.data?.lesson?.semester?.start)
            }
        }

        if (data?.data?.data?.lesson?.semester?.end) {
            setEndDate(data?.data?.data?.lesson?.semester?.end)
        }

    }, [data])


    return (
        <StudentLayout pageTitle={'درس‌های من'} backTo={URLS.student.lessons.myLesson.list}>
            <RenderIf condition={isPending}>
                <Spin spinning={true}/>
            </RenderIf>

            <RenderIf condition={isSuccess}>


                <div className="container mx-auto  pt-2 max-w-7xl">

                    <Badge.Ribbon text={' کد درس: ' + toFaNumber(data?.data?.data?.lesson?.code)}></Badge.Ribbon>
                    <div className="rounded-2xl shadow-lg p-8 mb-8 border border-gray-100 dark:border-gray-600">
                        <div className="flex flex-col lg:flex-row gap-8">
                            <div className="flex-1">
                                <div className="flex items-start gap-4 mb-6">
                                    <div className="hidden md:flex p-3 bg-blue-100 rounded-xl">
                                        <BookOpen className="w-8 h-8 text-blue-600"/>
                                    </div>
                                    <div className="flex-1">
                                        <h1 className="text-3xl font-bold  mb-2">{data?.data?.data?.lesson?.topic?.title}
                                            {' '}
                                            <span
                                                className={`px-3 py-1 rounded-full text-xs font-medium border ${lessonRegisterStatusEnum(data?.data?.data?.status, 'color')}`}>
                                                  {lessonRegisterStatusEnum(data?.data?.data?.status)}
                                                </span>
                                        </h1>
                                        <p className=" text-lg mb-4">{data?.data?.data?.lesson?.title}</p>
                                        <div className="flex items-center gap-4 text-sm ">
                                            <div className="flex items-center gap-1">
                                                <UserIcon className="w-4 h-4 fill-current"/>
                                            </div>
                                            <div>{data?.data?.data?.lesson?.count}</div>
                                            <span> دانش آموز</span>
                                        </div>
                                    </div>
                                </div>

                                {/* Progress Bar */}
                                <div className="mb-6">
                                    <div className="flex justify-between items-center mb-2">
                                        <span className="text-sm font-medium">پیشرفت دوره</span>
                                        <span
                                            className="text-sm ">{progressBetweenDates(startDate, endDate)?.percentElapsed}%</span>
                                    </div>
                                    <div className="w-full bg-gray-200 rounded-full h-3">
                                        <div
                                            className="bg-gradient-to-r from-blue-500 to-emerald-500 h-3 rounded-full transition-all duration-500"
                                            style={{width: `${progressBetweenDates(startDate, endDate)?.percentElapsed}%`}}
                                        ></div>
                                    </div>
                                    <div className="flex justify-between text-xs  mt-1">
                                        <span>شروع: {formatDate(startDate)}</span>
                                        <span>پایان: {formatDate(endDate)}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Instructor Info */}
                            <div className="lg:w-80">
                                <div className="bg-gradient-to-br from-blue-100 to-emerald-100 dark:from-blue-800 dark:to-emerald-500 rounded-xl p-6">
                                    <div className="text-center">
                                        <RenderIf condition={data?.data?.data?.lesson?.teacher}>
                                            <Avatar
                                                src={data?.data?.data?.lesson?.teacher_detail?.avatar}
                                                alt={data?.data?.data?.lesson?.teacher_detail?.firstname}
                                                className="w-20 h-20 rounded-full mx-auto mb-4 border-4 border-white shadow-md"
                                            />
                                            <h3 className="text-lg font-semibold  mb-1">
                                                {teacherGenderNames[data?.data?.data?.lesson?.teacher_detail?.gender]} {' '}
                                                {data?.data?.data?.lesson?.teacher_detail?.firstname}
                                                {' '}
                                                {data?.data?.data?.lesson?.teacher_detail?.lastname}
                                            </h3>

                                            <p className=" text-sm mb-4">استاد دوره</p>
                                        </RenderIf>
                                        <div className="space-y-2 text-sm">
                                            <div className="flex items-center justify-center gap-2 ">
                                                {(data?.data?.data?.lesson?.times && data?.data?.data?.lesson?.times.length > 0) &&
                                                    <div className="flex items-center ">
                                                        <Clock className="w-4 h-4 ml-2 text-green-500"/>
                                                        <span
                                                            className="text-sm">{data?.data?.data?.lesson?.times?.map((t, index) => (
                                                            <>
                                                                    <span className={'flex flex-wrap gap-1'}>
                                                                        <span
                                                                            className={'font-bold'}>{weekdayString(t.weekday)}</span>
                                                                        <span>{t.classroom.title}</span>
                                                                        <span>{toFaNumber(t.start)} - {toFaNumber(t.end)}</span>
                                                                    </span>
                                                            </>
                                                        ))} </span>
                                                    </div>}
                                            </div>
                                            <RenderIf condition={data?.data?.data?.lesson.examdate}>
                                                <div className="flex items-center justify-center gap-2 ">
                                                    <Calendar className="w-4 h-4"/>
                                                    <span>آزمون: {data?.data?.data?.lesson.examdate}</span>
                                                </div>
                                            </RenderIf>

                                        </div>

                                        {/*<div className="mt-4 p-3 rounded-lg border">*/}
                                        {/*    <p className="text-xs  mb-1">جلسه بعدی</p>*/}
                                        {/*    <p className="text-sm font-medium ">sss</p>*/}
                                        {/*</div>*/}
                                    </div>

                                </div>

                            </div>

                        </div>
                        <ShowMyLessonAddress data={data?.data?.data?.lesson?.times}/>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                        {/* Main Content */}

                        <div className="lg:col-span-2 space-y-8">
                            <StudentMyLessonBookResourceSection data={data} />
                            <HomeworkSection id={param.id} lessonDetail={data?.data?.data?.lesson}/>
                            <AbsenceSection id={param.id} takenunit={data}/>

                            <RenderIf condition={data?.data?.data?.academytransactions?.length > 0}>
                                <StudentMyLessonPaymentHistorySection data={data}/>

                            </RenderIf>
                        </div>


                        {/* Sidebar */}
                        <div className="space-y-8">
                            <RenderIf condition={true}>
                                {/* Quick Stats */}
                                <div className="rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                                    <h3 className="text-lg font-semibold  mb-4">وضعیت</h3>
                                    <div className="space-y-4">
                                        <div className="flex items-center justify-between">
                                            <span className="">تعداد غیبت‌ها</span>
                                            <span
                                                className="font-semibold">{data?.data?.data?.absences_count ?? 0} جلسه </span>
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <span className="">تکالیف ارسالی</span>
                                            <span
                                                className="font-semibold">{data?.data?.data?.homework_reports_count ?? '-'} مورد </span>
                                        </div>

                                        <div className="flex items-center justify-between">
                                            <span className="">نمره نهایی</span>
                                            <span
                                                className="font-semibold text-green-600">{data?.data?.data?.score ?? '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </RenderIf>

                            <RenderIf condition={data?.data?.data?.installments?.length > 0}>
                                <InstallmentSection data={data}/>
                            </RenderIf>


                            <RenderIf
                                condition={data?.data?.data?.lesson?.topic?.exam && data?.data?.data?.status === 'taken'}>
                                <ExamStartSection data={data}/>
                            </RenderIf>


                            <RenderIf condition={data?.data?.data?.status === 'taken'}>
                                <RemoveLesson data={data}/>
                            </RenderIf>


                        </div>
                    </div>


                </div>
            </RenderIf>


        </StudentLayout>
    );

}

export default StudentShowMyLessonPage;